import {
  DKLabel,
  DKButton,
  DKIcon,
  DKIcons,
  DKTooltipWrapper,
} from "deskera-ui-library";

import ic_info_warning from "../../assets/icons/ic_info_warning.svg";
import { isMobileWebView } from "../../utility/ViewportSizeUtils";

const ReadWatchComponent = (props) => {

    return (
        <div className="row parent-width banner-holder">
            <div className="column bg-deskera-secondary p-r border-radius-m border-m parent-width">
          <DKLabel text={`<span style="font-size:20px">🙋‍♂️ </span> ${props.title}` }  />

          <div className="row mt-r ml-l">
            <DKButton
              className="border-m bg-white"
              title="Read"
              onClick={props.onRead}
            />
            <DKButton
              className="border-m ml-r bg-white"
              title="Watch"
              onClick={props.onWatch}
            />
          </div>
        </div>
        { ((!isMobileWebView() && props.export) || props.import) &&
          <div className="column bg-deskera-secondary p-r border-radius-m border-m parent-width ml-l banner-holder">
          <div className="d-flex align-items-center">
             <DKLabel text={`<span style="font-size:20px">💼</span> ${(props.exportTitle)? props.exportTitle: ''} `}/>

             {props.exportTitleInfo &&
                    <DKTooltipWrapper
                        content={props.exportTitleInfo}
                        tooltipClassName="warning-tooltip-prop "
                    >
                      <DKIcon className="mr-s ic-s"  src={ic_info_warning} />
                    </DKTooltipWrapper>
             }
          </div>


            <div className="row mt-r ml-l">

              {props.import && <DKButton
                title={props.import}
                // isReverse={true}
                icon={DKIcons.ic_import}
                className="border-m bg-white"
                onClick={() =>
                  props.onImportClick()
                }
              />}
              {(props.export && !isMobileWebView())&& <div className="row position-relative ml-r">
                <DKButton
                  title={props.export}
                  icon={DKIcons.ic_export}
                  className={`border-m bg-white  ${(props.export == "Exporting...") ? " pointer-events-none " : "" } `}
                  onClick={() => {
                    if(props.onExportClick) {
                      props.onExportClick()
                    }
                  }}
                />

              </div>}
            </div>
          </div>
        }
        </div>
    )
}

export default ReadWatchComponent
